import React, { useMemo } from 'react';
import qrcode from 'qrcode-generator';

/** The dark modules of `text` as one SVG path (`M x y h1 v1 h-1 z` per module). */
export function qrPath(text) {
  const qr = qrcode(0, 'M');
  qr.addData(String(text || ''));
  qr.make();
  const n = qr.getModuleCount();
  let d = '';
  for (let r = 0; r < n; r += 1) {
    for (let c = 0; c < n; c += 1) {
      if (qr.isDark(r, c)) d += `M${c + 4} ${r + 4}h1v1h-1z`;
    }
  }
  return { d, size: n + 8 }; // 4-module quiet zone on every side
}

/** A QR code for a phone camera. Always dark on white, whatever the theme. */
export default function QrCode({ text, size = 120, label }) {
  const { d, size: modules } = useMemo(() => qrPath(text), [text]);
  return (
    <svg
      className="pj-share-qr"
      width={size}
      height={size}
      viewBox={`0 0 ${modules} ${modules}`}
      role="img"
      aria-label={label}
      data-testid="share-qr"
      shapeRendering="crispEdges"
    >
      <rect width={modules} height={modules} fill="#ffffff" />
      <path d={d} fill="#000000" />
    </svg>
  );
}
